import React, {useState} from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub';
import { Link } from 'react-router-dom';
import { userMenuTxt } from 'config/translate/variables';
import CartAction from 'actions/Cart';
import LoginRegister from 'components/Header/LoginRegister';
import RepeatLastOrder from 'components/RepeatLastOrder';
import StorageService from 'services/StorageService';
import OrderTracking from 'components/Header/OrderTracking';
import { ecommerce } from 'config/constants';
import { HtmlParse } from 'utils';
import logoPrime from 'images/icons/logo-jumbo-prime.svg';
import { paymentDebitWallet, frequentProductsID } from 'config';
import useVariant from 'hooks/useVariant';
import { primeFlag } from 'config';

const UserLinks = (props) => {
    const {logged, firstName, closeMenuUrl} = props;
    const [show, setShow] = useState(false);

    const variant = useVariant(frequentProductsID);
    const newVariant = variant === '1' ;
    const dataUser = StorageService.getSecureItem('userData');
    const notPrime = !(dataUser.CencoPrime_2020 || dataUser.CencoPrime_CAT);

    const logout = () => {
        CartAction.logout(()=> {CartAction.logoutRedirect()});
    }

    const clickFrequentProducts = (tag, url, variant) => {
        closeMenuUrl('/productos-frecuentes');
        closeMenuUrl(tag, url, variant);
    };

    const _openPrimeRegister = () => {
        PubSub.dispatch('drawer_register_prime_open')
    }

    return (
        <section className={'new-mobile-menu-account' + (!logged ? ' logout ' : '')}>
            {(!logged) && <div className={"new-mobile-menu-account-btns"}>
                <LoginRegister/>
            </div>}
            {(logged && firstName) &&
            <>
                <button className="last-order user-account" onClick={() => setShow(true)}>
                    <span className="menu-options-title">
                        <i className="menu-icon jumbo-icon-user"></i>{userMenuTxt.account}
                    </span>
                    <i className="font-icn arrow-up" />
                </button>
                {ecommerce.whiteLabel && <OrderTracking offers={props.offers}/>}
                <RepeatLastOrder />

                {!ecommerce.whiteLabel && newVariant && <Link to="/productos-frecuentes" className="menu-mobile-frequent-products" onClick={() => clickFrequentProducts('Productos Frecuentes','Menu Mobile','Variante 1')}>
                    <button className="menu-mobile-frequent-products-button-wrap" >
                        <i className="jumbo-icon-frequent-product"></i>
                        <span className="menu-mobile-frequent-products-title">Productos frecuentes</span>
                    </button>
                </Link>}

                {<div className={"my-account-menu " + (show ? ' open ' : '')}>
                    <button className="my-account-title-wrap" onClick={() => setShow(false)}>
                        <i className="font-icn arrow-up"></i>
                        <span className="my-account-title"> Mi cuenta</span>
                    </button>

                    <ul className="my-account-items-wrap">
                        <li><Link className="my-account-item-text" to="/mis-datos" onClick={() => closeMenuUrl('/mis-datos')}>{userMenuTxt.info}</Link></li>
                        <li ><Link className="my-account-item-text" to="/mis-compras" onClick={() => closeMenuUrl('/mis-compras')}>{userMenuTxt.orders}</Link></li>
                        <li><Link className="my-account-item-text"  to="/mis-listas-de-compras" onClick={() => closeMenuUrl('/mis-listas-de-compras')}>{userMenuTxt.lists}</Link></li>
                        <li><Link className="my-account-item-text"  to="/mis-tarjetas" onClick={() => closeMenuUrl('/mis-tarjetas')}>{userMenuTxt.cards}</Link></li>
                        {!ecommerce.whiteLabel && !newVariant && <li><Link className="my-account-item-text"  to="/productos-frecuentes" onClick={() => clickFrequentProducts('Productos Frecuentes','Menu Mobile','Variante 0')}>{userMenuTxt.frequentProducts}</Link></li>}
                        <li className="my-account-item-wrap">
                            <Link className="my-account-item-text" to="/productos-favoritos" onClick={() => closeMenuUrl('/productos-favoritos')}>{userMenuTxt.favoriteProducts}</Link>
                        </li>

                        {(notPrime && primeFlag) && <li className={"my-account-item-wrap " + (notPrime ? ' no-prime' : '')} onClick={_openPrimeRegister}> 
                            Quiero ser <i className="logo-prime">{HtmlParse(logoPrime)}</i>
                        </li>}

                        {(!notPrime && primeFlag) && <li className="my-account-item-wrap"> 
                            <Link className="my-account-item-text" to="/prime" onClick={() => closeMenuUrl('/prime')}>{userMenuTxt.prime.userPrime}</Link>
                            <i className="logo-prime">{HtmlParse(logoPrime)}</i>
                        </li>}

                        {paymentDebitWallet && <li><Link className="my-account-item-text"  to="/mi-cuenta-bancaria" onClick={() => closeMenuUrl('/mi-cuenta-bancaria')}>{userMenuTxt.bank}</Link></li>}
                        <li onClick={logout}><a className="new-link new-link-small my-account-item-text log-out" >{userMenuTxt.logout}</a></li>
                    </ul>
                </div>}
            </>
            }
        </section>
    );
}

UserLinks.propTypes = {
    logged: PropTypes.string,
    firstName: PropTypes.string,
    closeMenuUrl: PropTypes.func,
};

export default UserLinks;
